
<div class="webhook-context-container">
    
    <div *ngIf="editMode" class="edit-panel">
        <div class="edit-panel-action">
            <button nz-button nzSize="small" nzType="primary" [nzLoading]="loadingAddButton" (click)="addRow()" class="search-button">{{'save'|translateTA}}</button>
            <!--button nz-button nzSize="small" (click)="clearRow()" class="search-button">{{'reset'|translateTA}}</button-->
            <button nz-button nzSize="small" nzDanger (click)="editMode=false;clearRow();newContext=false;">{{'cancel'|translateTA}}</button>
        </div>
        <nz-divider *ngIf="newContext" nzText="{{'workflow.new.context'|translateTA}}" nzOrientation="right"></nz-divider>
        <nz-divider *ngIf="!newContext" nzText="{{'workflow.edit.context'|translateTA:{codecompany:CODECOMPANY} }}" nzOrientation="right"></nz-divider>
        <div class="edit-panel-container">
                <webhook-form-search [mainformGroup]="newRow"  [field]="codeCompanyField" ></webhook-form-search>
      
                <webhook-form-select [mainformGroup]="newRow"  [field]="activeField" ></webhook-form-select>
                <webhook-form-input [mainformGroup]="newRow"  [field]="scheduleField" ></webhook-form-input>
        
                <webhook-form-query-select [mainformGroup]="newRow"  [field]="servernameField" ></webhook-form-query-select>
                <webhook-form-select [mainformGroup]="newRow"  [field]="environmentField" ></webhook-form-select>
        </div>
        
    </div>
    <button nz-button nzType="primary" nzShape="circle" *ngIf="!editMode" (click)="editMode=true;newContext=true;clearRow();newRow.get('CODECOMPANY').enable();" class="add-button">
      <nz-icon nzType="plus" />
    </button>
    <nz-table #contextTable *ngIf="!editMode"
            [nzData]="contexts" 
            [nzBordered]="true"   
            [nzScroll]="{ y: '240px' }" 
            nzSize="small" 
            nzShowSizeChanger
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzPageIndex]="pageIndex"
            [nzTableLayout]="'fixed'"
            (nzQueryParams)="onQueryParamsChange($event)"
            class="context-table">
        <thead>

           
            <tr>
                <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="CODECOMPANY">{{'codecompany'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.CODECOMPANY" [nzActive]="contextTable.data.length > 0" [nzDropdownMenu]="menuCompany">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="ACTIVE">{{'active'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.ACTIVE" [nzActive]="contextTable.data.length > 0" [nzDropdownMenu]="menuActive">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal">{{'schedule'|translateTA}} </th>
                <th  class="cell-normal" nzCustomFilter  nzShowSort [nzSortFn]="true" nzColumnKey="ENVIRONMENT">{{'environment'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.ENVIRONMENT" [nzActive]="contextTable.data.length > 0" [nzDropdownMenu]="menuEnvironment">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  class="cell-normal">{{'servername'|translateTA}}
                    <nz-filter-trigger [(nzVisible)]="visible.SERVERNAME"  [nzActive]="contextTable.data.length > 0" [nzDropdownMenu]="menuServername">
                        <nz-icon nzType="search" />
                    </nz-filter-trigger>
                </th>
                <th  nzWidth="100px" >{{'actions'|translateTA}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let v of contextTable.data" (dblclick)="editContextDoubleClick(v)">
                <td  class="cell-normal">{{ v.CODECOMPANY }} - {{v['FK_MKTPCFGCOMPANY_MKTPCOMPANIES->NAME']}}</td>
                <td   class="cell-normal">{{ v.ACTIVE }} - {{getActiveDesc(v.ACTIVE)}}</td>
                <td   class="cell-normal">{{ v.SCHEDULE }}</td>
                <td   class="cell-normal">{{ v.ENVIRONMENT }} - {{getEnvironmentDesc(v.ENVIRONMENT)}}</td>
                <td   class="cell-normal">{{ v.SERVERNAME }}</td>
                <td>
                     <button nz-button nzType="primary" nzShape="circle"  (click)="editContext(v)" class="search-button">
                        <nz-icon nzType="edit" />
                    </button>
                    <button nz-button nzType="primary" nzShape="circle" nzDanger [nzLoading]="loadingRemoveButton" (click)="deleteContext(v)">
                        <nz-icon nzType="delete" />
                    </button>
                    
                </td>
            </tr>
        </tbody>
    </nz-table>
</div>

<nz-dropdown-menu #menuCompany="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-search [mainformGroup]="filterFormGroup"  [field]="codeCompanyField" ></webhook-form-search>
          <button nz-button nzSize="small" nzType="primary" (click)="search('CODECOMPANY')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('CODECOMPANY')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuEnvironment="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-select [mainformGroup]="filterFormGroup"  [field]="environmentField" ></webhook-form-select>
          <button nz-button nzSize="small" nzType="primary" (click)="search('ENVIRONMENT')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('ENVIRONMENT')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuActive="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-select [mainformGroup]="filterFormGroup"  [field]="activeField" ></webhook-form-select>
          <button nz-button nzSize="small" nzType="primary" (click)="search('ACTIVE')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('ACTIVE')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>

<nz-dropdown-menu #menuServername="nzDropdownMenu">
      <div class="ant-table-filter-dropdown">
        <div class="search-box">
          <!--input type="text" nz-input placeholder="{{'search'|translateTA}}" [(ngModel)]="searchCodecompany" /-->
          <webhook-form-input [mainformGroup]="filterFormGroup"  [field]="servernameField" ></webhook-form-input>
          <button nz-button nzSize="small" nzType="primary" (click)="search('SERVERNAME')" class="search-button">{{'search'|translateTA}}</button>
          <button nz-button nzSize="small" (click)="reset('SERVERNAME')">{{'reset'|translateTA}}</button>
        </div>
      </div>
</nz-dropdown-menu>


